import React from "react";
import { Redirect, Switch } from "react-router-dom";
import PrivateRoute from "../../../routes/PrivateRoute";

import LandingPage from "../../pages/LandingPage/LandingPage";
import LoginPage from "../../pages/LoginPage/LoginPage";

function GuestPage({ history }) {
  return (
    <Switch>


      <PrivateRoute
        path="/login"
        history={history}
        component={LoginPage}
      />

      <PrivateRoute path="/" history={history} component={LandingPage} />
    </Switch>
  );
}

GuestPage.propTypes = {};

export default GuestPage;
